import React from "react";
import PageTitle from "../Dashboard/PageTitle";
import "../Dashboard/main.css";
import MomentumTradesContainer from "./MomentumTradesContainer";

function MomentumTradesmain() {
  return (
    <main id="main" className="main">
      <PageTitle page={"MomentumTrades"} />
      <MomentumTradesContainer />
    </main>
  );
}

export default MomentumTradesmain;
